import React from "react";
import { Box } from "@mui/material";
import Typography from "components/basic/typography";

interface WizardSectionProps {
  title: string;
  children: React.ReactNode;
}

const WizardSection: React.FC<WizardSectionProps> = ({ title, children }) => (
  <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
    <Typography variant="h4" align="inherit">
      {title}
    </Typography>

    {children}
  </Box>
);

export default WizardSection;
